const ONES = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const TENS = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

function wordsBelow100(n: number): string {
  if (n === 0) return "";
  if (n < 20) return ONES[n];
  const t = Math.floor(n / 10);
  const o = n % 10;
  return o ? `${TENS[t]} ${ONES[o]}` : TENS[t];
}

function wordsBelow1000(n: number): string {
  if (n === 0) return "";
  const h = Math.floor(n / 100);
  const rest = n % 100;
  const hundred = h ? `${ONES[h]} Hundred` : "";
  const tail = wordsBelow100(rest);
  if (hundred && tail) return `${hundred} ${tail}`;
  return hundred || tail;
}

function integerToIndianWords(n: number): string {
  if (n === 0) return "Zero";
  if (n < 0) return `Negative ${integerToIndianWords(-n)}`;

  const parts: string[] = [];
  let num = Math.floor(n);

  const crore = Math.floor(num / 10000000);
  num %= 10000000;
  if (crore) {
    parts.push(`${integerToIndianWords(crore)} Crore`);
  }

  const lakh = Math.floor(num / 100000);
  num %= 100000;
  if (lakh) {
    parts.push(`${integerToIndianWords(lakh)} Lakh`);
  }

  const thousand = Math.floor(num / 1000);
  num %= 1000;
  if (thousand) {
    parts.push(`${integerToIndianWords(thousand)} Thousand`);
  }

  if (num > 0) {
    parts.push(wordsBelow1000(num));
  }

  return parts.join(" ").replace(/\s+/g, " ").trim();
}

export function sanitizeInrAmountInput(raw: string): string {
  return raw.replace(/[^\d,]/g, "");
}

export function formatInrDisplayAmount(
  amount: number | null | undefined
): string | null {
  if (amount == null || !Number.isFinite(amount)) {
    return null;
  }

  return amount.toLocaleString("en-IN");
}

export function parseInrAmountInput(raw: string): number | null {
  const t = raw.trim().replace(/^₹\s*/, "");
  if (!t) return null;
  const cleaned = t.replace(/,/g, "").replace(/[^\d.]/g, "");
  if (!cleaned || cleaned === ".") return null;
  const n = Number.parseFloat(cleaned);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

export function formatInrAmountInWords(
  amount: number | null | undefined
): string | null {
  if (amount == null || !Number.isFinite(amount) || amount < 0) return null;

  const rupees = Math.floor(amount);
  const paise = Math.round((amount - rupees) * 100);

  if (rupees === 0 && paise === 0) return "Zero Rupees";

  let words = `${integerToIndianWords(rupees)} Rupees`;
  if (paise > 0) {
    words += ` and ${wordsBelow100(paise)} Paise`;
  }
  return words;
}

export function inrAmountWordsFromText(
  raw: string | number | null | undefined
): string | null {
  if (raw == null) return null;
  const text = typeof raw === "number" ? String(raw) : raw;
  if (!text.trim()) return null;
  const n = parseInrAmountInput(text);
  if (n == null) return null;
  return formatInrAmountInWords(n);
}
